module.exports = __webpack_public_path__ + "static/media/Contract Manufacturers Infographic - Desktop - 16-04-2025 C.a2ee8ef1.gif";